import React from 'react';
import { Link } from 'react-router-dom'; 

const NotFound = () => {
  return (
    <div style={{ textAlign: 'center', padding: '50px' }}>
      <h1>404 - Page Not Found</h1>
      <p>The page you're looking for doesn't exist.</p>
      <Link to="/" style={{ textDecoration: 'none', color: 'blue' }}>
        <button style={{ padding: '10px 20px', fontSize: '16px' }}>
          Go to Homepage
        </button>
      </Link>
    </div>
  );
};

export default NotFound;
